module.exports = __webpack_public_path__ + "media/smartvideo.837dc55f.mp4";